import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCalculator,
  faCode,
  faBullhorn,
  faGraduationCap,
  faHeartPulse,
  faBriefcase,
  faChartLine,
  faLaptopCode,
  faPaintBrush,
  faHandshake,
  faHeadset,
  faMicroscope
} from "@fortawesome/free-solid-svg-icons";
import "./jobCategories.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchJobCategoryListAsync,
  selectJobCategoryList,
} from "./JobCategorySlice/JobCategorySlice";
import { SkeletonCircle, SkeletonText, Box } from '@chakra-ui/react';
import { NoDataFound } from '../../pages/CommonPublicPages/Basic/NoDataFound';
// import { NoDataFound } from './NoDataFound';

const colorMap = {
  "Accounting / Finance": "green",
  "Engineering": "blue",
  "Marketing": "red",
  "Education": "yellow",
  "Healthcare": "purple",
  "Business": "orange",
  "Information Technology": "gray",
  "Design": "pink",
  "Human Resources": "teal",
  "Sales": "indigo",
  "Customer Service": "cyan",
  "Research": "lime"
};

const iconMap = {
  "Accounting / Finance": faCalculator,
  "Engineering": faCode,
  "Marketing": faBullhorn,
  "Education": faGraduationCap,
  "Healthcare": faHeartPulse,
  "Business": faChartLine,
  "Information Technology": faLaptopCode,
  "Design": faPaintBrush,
  "Human Resources": faHandshake,
  "Sales": faChartLine,
  "Customer Service": faHeadset,
  "Research": faMicroscope
};

export function JobCategories() {
  const dispatch = useDispatch();
  const categories = useSelector(selectJobCategoryList);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(fetchJobCategoryListAsync())
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [dispatch]);

  const categories1 = [
    {
      name: "Interview Preparation",
      bgColor: "bg-red-100",
      textColor: "text-red-700",
      svgBg: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 560'><g fill='none'><rect width='1440' height='560' fill='%23fff7f3'/><path d='M0%2c676.347C125.055%2c680.879%2c178.572%2c509.181%2c286.166%2c445.284C399.757%2c377.826%2c575.863%2c407.32%2c643.8%2c294.014C710.806%2c182.262%2c625.339%2c41.722%2c605.34%2c-87.035C585.605%2c-214.096%2c606.056%2c-355.253%2c527.182%2c-456.806C447.191%2c-559.796%2c314.373%2c-615.788%2c184.612%2c-628.731C64.667%2c-640.695%2c-42.845%2c-571.193%2c-154.083%2c-524.76C-252.966%2c-483.484%2c-361.655%2c-455.11%2c-429.675%2c-372.316C-496.95%2c-290.429%2c-513.598%2c-180.776%2c-523.383%2c-75.251C-532.78%2c26.084%2c-530.255%2c130.349%2c-484.726%2c221.367C-440.028%2c310.724%2c-345.989%2c356.635%2c-273.14%2c425.014C-181.063%2c511.44%2c-126.201%2c671.773%2c0%2c676.347' fill='%23ffebe3'/></g></svg>")`,
      icon: "🚀",
    },
    {
      name: "Skill Development",
      bgColor: "bg-blue-100",
      textColor: "text-blue-700",
      svgBg: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 560'><g fill='none'><rect width='1440' height='560' fill='%23f2faff'/><path d='M0%2c676.347C125.055%2c680.879%2c178.572%2c509.181%2c286.166%2c445.284C399.757%2c377.826%2c575.863%2c407.32%2c643.8%2c294.014C710.806%2c182.262%2c625.339%2c41.722%2c605.34%2c-87.035C585.605%2c-214.096%2c606.056%2c-355.253%2c527.182%2c-456.806C447.191%2c-559.796%2c314.373%2c-615.788%2c184.612%2c-628.731C64.667%2c-640.695%2c-42.845%2c-571.193%2c-154.083%2c-524.76C-252.966%2c-483.484%2c-361.655%2c-455.11%2c-429.675%2c-372.316C-496.95%2c-290.429%2c-513.598%2c-180.776%2c-523.383%2c-75.251C-532.78%2c26.084%2c-530.255%2c130.349%2c-484.726%2c221.367C-440.028%2c310.724%2c-345.989%2c356.635%2c-273.14%2c425.014C-181.063%2c511.44%2c-126.201%2c671.773%2c0%2c676.347' fill='%23e3f1ff'/></g></svg>")`,
      icon: "📖",
    },
    {
      name: "Internship",
      bgColor: "bg-green-100",
      textColor: "text-green-700",
      svgBg: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 560'><g fill='none'><rect width='1440' height='560' fill='%23f3fff9'/><path d='M0%2c676.347C125.055%2c680.879%2c178.572%2c509.181%2c286.166%2c445.284C399.757%2c377.826%2c575.863%2c407.32%2c643.8%2c294.014C710.806%2c182.262%2c625.339%2c41.722%2c605.34%2c-87.035C585.605%2c-214.096%2c606.056%2c-355.253%2c527.182%2c-456.806C447.191%2c-559.796%2c314.373%2c-615.788%2c184.612%2c-628.731C64.667%2c-640.695%2c-42.845%2c-571.193%2c-154.083%2c-524.76C-252.966%2c-483.484%2c-361.655%2c-455.11%2c-429.675%2c-372.316C-496.95%2c-290.429%2c-513.598%2c-180.776%2c-523.383%2c-75.251C-532.78%2c26.084%2c-530.255%2c130.349%2c-484.726%2c221.367C-440.028%2c310.724%2c-345.989%2c356.635%2c-273.14%2c425.014C-181.063%2c511.44%2c-126.201%2c671.773%2c0%2c676.347' fill='%23e3f7ed'/></g></svg>")`,
      icon: "🎓",
    },
    {
      name: "Hackathon",
      bgColor: "bg-yellow-100",
      textColor: "text-yellow-700",
      svgBg: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 560'><g fill='none'><rect width='1440' height='560' fill='%23fff9e3'/><path d='M0%2c676.347C125.055%2c680.879%2c178.572%2c509.181%2c286.166%2c445.284C399.757%2c377.826%2c575.863%2c407.32%2c643.8%2c294.014C710.806%2c182.262%2c625.339%2c41.722%2c605.34%2c-87.035C585.605%2c-214.096%2c606.056%2c-355.253%2c527.182%2c-456.806C447.191%2c-559.796%2c314.373%2c-615.788%2c184.612%2c-628.731C64.667%2c-640.695%2c-42.845%2c-571.193%2c-154.083%2c-524.76C-252.966%2c-483.484%2c-361.655%2c-455.11%2c-429.675%2c-372.316C-496.95%2c-290.429%2c-513.598%2c-180.776%2c-523.383%2c-75.251C-532.78%2c26.084%2c-530.255%2c130.349%2c-484.726%2c221.367C-440.028%2c310.724%2c-345.989%2c356.635%2c-273.14%2c425.014C-181.063%2c511.44%2c-126.201%2c671.773%2c0%2c676.347' fill='%23f7e3b4'/></g></svg>")`,
      icon: "👥",
    },
  ];

  // Function to render the job categories section
  const renderJobCategories = () => {
    if (isLoading) {
      // Skeleton Loader when data is loading
      return Array.from({ length: 6 }).map((_, index) => (
        <div className="flex flex-row justify-evenly px-3 gap-5" key={index}>
          <Box width={"xl"} padding="6" boxShadow="lg" bg="white">
            <SkeletonCircle size="10" />
            <SkeletonText
              mt="4"
              noOfLines={4}
              spacing="4"
              skeletonHeight="2"
            />
          </Box>
        </div>
      ));
    } else if (!categories || categories.length === 0) {
      // No data state using the NoDataFound component
      return (
        <div className="col-span-1 sm:col-span-2 lg:col-span-3">
          <NoDataFound
            title="No Job Categories Found"
            message="We couldn't find any job categories at the moment. Please check back later."
          />
        </div>
      );
    } else {
      // Actual Data Rendering
      return Array.isArray(categories) && categories.slice(0, 6).map((category, index) => {
        const icon = iconMap[category.title] || faBriefcase;
        const color = colorMap[category.title] || "blue";
        return (
          <div
            key={category.uuid}
            className="group bg-white hover:shadow-lg border-black-100 overflow-hidden inset-0 border-2 rounded-xl transition-all duration-300 hover:border-blue-500"
          >
            <Link to={`/job-categories/${category.uuid}`} className="block p-6 relative">
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 w-12 h-12 rounded-lg bg-${color}-100 flex items-center justify-center`}>
                  <FontAwesomeIcon
                    icon={icon}
                    className={`text-${color}-500 text-2xl`}
                  />
                </div>
                <div className="flex-grow">
                  <h3 className="text-lg text-start font-semibold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-gray-500 text-start text-sm mb-2 ">
                    ({category.job_count} opening positions)
                  </p>
                </div>
              </div>
            </Link>
          </div>
        );
      });
    }
  };

  return (
    <div className="py-12 job-categories">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-4xl text-center font-semibold text-gray-900 mb-14">
          Find the Perfect Opportunity For You
        </div>

        <div className="flex gap-6 justify-center flex-wrap px-4">
          {categories1.map((category, index) => (
            <div
              key={index}
              className={`w-full sm:w-72 h-36 p-4 rounded-lg shadow-md flex flex-col items-center justify-center relative ${category.bgColor}`}
              style={{
                backgroundImage: `${category.svgBg}`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="text-3xl">{category.icon}</div>
              <div className={`text-lg font-semibold ${category.textColor}`}>
                {category.name}
              </div>
              <div className="text-sm text-gray-600 mt-2">
                {index === 0 && "Stand out to employers"}
                {index === 1 && "Up your interview success rate"}
                {index === 2 && "Upskill to get ahead"}
                {index === 3 && "Grow with peers & mentors"}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center py-12">
          <h2 className="text-4xl font-semibold text-gray-900 mb-2">
            Most Searched <span className="text-green-600">Job Categories</span>
          </h2>
          <p className="text-gray-600 text-lg underline">2024 jobs live - 293 added today.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 px-4 sm:px-2 gap-6">
          {renderJobCategories()}
        </div>
      </div>
    </div>
  );
}